/**
 * True in a real browser tab, false under Node (Vitest's default `node`
 * environment included) or during the landing's prerender. A module-level
 * constant rather than a function: the runtime does not change mid-process,
 * so there is nothing to recompute.
 */
export const isBrowser = typeof window !== "undefined";
